module.exports = __webpack_public_path__ + "img/assessment.eb1bead6.svg";